module.exports = __webpack_public_path__ + "img/lunbo02_01.7b30b1ce.png";